// The two handoffs that cross a <script> boundary.
//
// bootstrap.js has already fetched `GET /i/config` before it decides to load us
// at all, so it hands the result over rather than making the widget fetch it
// again. Same idea for the rrweb vendor bundle: it is an IIFE loaded on demand,
// so it publishes `record` on a global that the widget picks up and deletes.
//
// Both globals are read once and removed. Nothing long-lived is left on the host
// page's `window`.

import type { WidgetConfig } from "./contract";

export const BOOT_GLOBAL = "__tinker_boot";
export const RRWEB_GLOBAL = "__tinker_rrweb";
export const BOOTED_FLAG = "__tinker_on";

/** The local dev tuning panel. Same script handoff as rrweb. */
export const TUNE_GLOBAL = "__tinker_tune";

/** Opt in to the circle-detector tuning panel. Development scaffolding only. */
export const TUNE_PARAM = "tinker_tune";

/** What bootstrap.js leaves on `window` for the widget bundle. */
export type BootPayload = {
  config: WidgetConfig;
  /** Origin-relative base for `/i` calls. "" means same origin. */
  apiBase: string;
  /** Absolute directory URL the bundles were served from, with a trailing slash. */
  assetBase: string;
  /** Installed capture authority. Hosted artifacts authenticate with their cookie. */
  authorization: string | null;
  /** The build rendered by an installed application, reported when capture opens. */
  observedBuildRef: string | null;
};
